import Cookies from "js-cookie";

export default new class SubheaderPromoBannerService {
    public init(): void {
        for (const closeFreeDeliveryBannerButton of document.querySelectorAll<HTMLButtonElement>(".js-free-delivery-banner-close")) {
            closeFreeDeliveryBannerButton.addEventListener("click", () => this.hideFreeDeliveryBanners());
        }
    }

    private hideFreeDeliveryBanners(): void {
        for (const closeFreeDeliveryBanner of document.querySelectorAll<HTMLAnchorElement>(".js-free-delivery-banner")) {
            closeFreeDeliveryBanner.classList.add("hidden");
        }

        Cookies.set("_fdbcb", "1", { expires: 14 });
    }
}();
